import * as React from "react";

const Spinner = () => {
  return (
    <div className="table_spinner">
      <span className="table_spinner_circle"></span>
    </div>
  );
};

export default Spinner;
